module.exports = __webpack_public_path__ + "fonts/41e8dea.ttf";